// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaFacebook_root__-_vG2"};